import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import PropTypes from "prop-types";
import {
  GridContainer,
  GridRow,
  GridColumn,
  Label,
  Button,
  Input,
  Utils,
  Loader,
} from "arv-reactcomponents";
import BackButton from "../../BackButton";
import MobileNumberInput from "../../Login/MobileNumberInput";
import PincodeInput from "../PincodeInput";
import TextAreaInput from "../TextAreaInput";
import { RETURNS } from "npmlinks-constants";
import UserNameInput from "../../Login/UserNameInput";
import { ADDRESS_REGEX } from "../../../constants/regex";

const {
  ADD_ADDRESS: {
    controls,
    EDIT,
    ADD,
    PINCODE_ERROR_MSG,
    DEFAULT_PINCODE_ERROR_MSG,
  },
} = RETURNS;

@inject("AddressStore")
@observer
class AddAddress extends Component {
  static renderLoader() {
    return (
      <div className="nw-bodyoverlay nw-addaddress-overlay">
        <div className="nw-bodyoverlay-loadercontainer">
          <Loader />
        </div>
      </div>
    );
  }
  constructor(props) {
    super(props);
    const {
      state,
      city,
      country,
      landmark,
      name,
      pincode,
      mobileNumber,
      alternateMobileNumber,
      firstLine,
    } = { ...this.props.editableAddress };
    this.state = {
      state,
      city,
      country,
      landmark,
      pincode,
      mobileNumber,
      alternateMobileNumber,
      firstLine,
      isAddressValid: false,
      name,
      isPincodeValid: false,
      isMobileNumberValid: false,
      isAlternateMobileNumberValid: false,
      isNameValid: false,
      mobileNumberCheck: "",
      pincodeErrorClass: "nwc-hidden",
      loader: false,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.pincodeHandler = this.pincodeHandler.bind(this);
    this.submitAddress = this.submitAddress.bind(this);

    this.landmarkHandler = this.landmarkHandler.bind(this);
    this.nameHandler = this.nameHandler.bind(this);
    this.addressHandler = this.addressHandler.bind(this);
    this.mobileHandler = this.mobileHandler.bind(this);
    this.alternatenumberHandler = this.alternatenumberHandler.bind(this);
    this.checkMobileHandler = this.checkMobileHandler.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  get isSubmit() {
    const {
      state,
      country,
      pincode,
      mobileNumber,
      firstLine,
      isAddressValid,
      name,
      isPincodeValid,
      isMobileNumberValid,
      isNameValid,
      alternateMobileNumber,
      isAlternateMobileNumberValid,
    } = this.state;
    let alternateMobileNumberCheck = true;
    if (alternateMobileNumber) {
      alternateMobileNumberCheck = isAlternateMobileNumberValid;
    }
    if (
      state &&
      country &&
      pincode &&
      mobileNumber &&
      firstLine &&
      !isAddressValid &&
      name &&
      isPincodeValid &&
      isMobileNumberValid &&
      isNameValid &&
      alternateMobileNumberCheck &&
      mobileNumber !== alternateMobileNumber
    ) {
      return true;
    }
    return false;
  }

  submitAddress() {
    const {
      state,
      country,
      pincode,
      landmark,
      city,
      mobileNumber,
      firstLine,
      name,
      alternateMobileNumber,
      isAlternateMobileNumberValid,
    } = this.state;

    let addAddressDetails = {
      country,
      isDefault: false,
      pincode,
      mobileNumber,
      alternateMobileNumber,
      firstLine,
      landmark,
      name,
      state,
      city,
    };
    if (isAlternateMobileNumberValid) {
      addAddressDetails = { ...addAddressDetails, alternateMobileNumber };
    }
    const { edit, editableAddress } = this.props;
    const { id: addressId, isDefault = false } = editableAddress;
    addAddressDetails = edit
      ? { ...addAddressDetails, isDefault }
      : addAddressDetails;
    this.props.onAddressSave(addAddressDetails, addressId, edit);
  }
  landmarkHandler(e) {
    const { value } = e.target;
    this.setState({ landmark: value });
  }

  nameHandler(value, nameField) {
    const { isValid: isNameValid } = nameField;
    this.setState({ name: value, isNameValid });
  }

  addressHandler(value) {
    this.setState({
      firstLine: value,
      isAddressValid: false,
    });
    const regexValue = ADDRESS_REGEX[1].pattern.test(value);
    if (!regexValue) {
      this.setState({
        isAddressValid: true,
      });
    }
  }

  checkMobileHandler() {
    const {
      mobileNumber,
      alternateMobileNumber,
      isAlternateMobileNumberValid,
      isMobileNumberValid,
    } = this.state;
    if (
      mobileNumber &&
      alternateMobileNumber &&
      isAlternateMobileNumberValid &&
      isMobileNumberValid &&
      mobileNumber === alternateMobileNumber
    ) {
      this.setState({
        mobileNumberCheck: "Please enter different mobile number.",
      });
      return false;
    }
    this.setState({
      mobileNumberCheck: "",
    });
    return true;
  }

  mobileHandler(mobileField) {
    const { value, isValid } = mobileField;
    this.setState(
      {
        mobileNumber: value,
        isMobileNumberValid: isValid,
      },
      () => {
        this.checkMobileHandler();
      },
    );
  }

  alternatenumberHandler(alternateNumberField) {
    const { value, isValid } = alternateNumberField;
    this.setState(
      { alternateMobileNumber: value, isAlternateMobileNumberValid: isValid },
      () => {
        this.checkMobileHandler();
      },
    );
  }
  pincodeHandler(pincodeField) {
    this.setState({
      pincodeErrorClass: "nwc-hide",
    });
    const { value: newPincode, isValid } = pincodeField;
    const { pincode } = this.state;
    if (pincode !== newPincode && isValid) {
      this.setState({ loading: true });
      const promises = [this.props.AddressStore.getPincodeDetails(newPincode)];
      Promise.all(promises)
        .then(([pincodeResponse]) => {
          this.setState({ loading: false });
          const [modifiedData] = pincodeResponse;
          let city = "";
          let state = "";
          let country = "";
          if (
            modifiedData &&
            modifiedData.pincode_city.name &&
            modifiedData.pincode_state.name &&
            modifiedData.pincode_country.name
          ) {
            (this.pincodeNotServicableMsg = ""),
              (city = modifiedData.pincode_city.name),
              (state = modifiedData.pincode_state.name),
              (country = modifiedData.pincode_country.name),
              this.setState({
                pincode: newPincode,
                isPincodeValid: true,
                city,
                state,
                country,
              });
          } else {
            (this.pincodeNotServicableMsg = PINCODE_ERROR_MSG),
              this.setState({
                isPincodeValid: false,
                pincodeErrorClass: "",
                pincode: "",
                city: "",
                state: "",
                country: "",
              });
          }
        })
        .catch(error => {
          this.setState({ loading: false });
          (this.pincodeNotServicableMsg = DEFAULT_PINCODE_ERROR_MSG),
            this.setState({
              isPincodeValid: false,
              pincodeErrorClass: "",
              pincode: "",
              city: "",
              state: "",
              country: "",
            });
        });
    } else {
      this.setState({ pincode: newPincode, isPincodeValid: isValid });
    }
  }

  onSubmit(e) {
    if (e) e.preventDefault();
    const {
      state,
      country,
      pincode,
      isPincodeValid,
      isMobileNumberValid,
      isNameValid,
      isAddressValid,
    } = this.state;

    if (
      isPincodeValid &&
      isNameValid &&
      isMobileNumberValid &&
      !isAddressValid &&
      pincode &&
      state &&
      country
    ) {
      this.submitAddress();
    }
  }

  handleKeyDown = function(e, callback) {
    if (e.key === "Enter" && e.shiftKey === false) {
      e.preventDefault();
      callback();
    }
  };

  get showPicodeData() {
    return !this.state.city && !this.state.state ? "nwc-hidden" : " ";
  }

  render() {
    const {
      city,
      state,
      country,
      landmark,
      name,
      pincode,
      mobileNumber,
      alternateMobileNumber,
      firstLine,
      mobileNumberCheck,
      pincodeErrorClass,
    } = this.state;
    const { edit, showBackButton, AddressStore, showLocalLoader } = this.props;
    const title = edit ? EDIT.title : ADD.title;
    const submit = edit ? EDIT.submit : ADD.submit;
    return (
      <div>
        {(showLocalLoader || this.state.loading) && AddAddress.renderLoader()}
        <form
          className="nw-addaddress-form"
          onSubmit={this.onSubmit}
          onKeyDown={e => {
            this.handleKeyDown(e, this.onSubmit);
          }}
        >
          {showBackButton && (
            <BackButton.component
              previous={this.props.previous}
              className="nw-returnsaddaddress-backbtn"
            />
          )}
          <h2 className="nw-returns-title">{title}</h2>
          <GridContainer>
            <GridRow>
              <GridColumn className="nwc-grid-col-sm nw-returns-inputblock">
                <Label htmlFor="firstName" className="nw-returns-label">
                  {controls.firstName}
                </Label>
                <UserNameInput.component
                  className="nwc-inp-secondary nw-returns-input"
                  name="firstName"
                  id="firstName"
                  placeholder=""
                  value={name}
                  userName={name}
                  onValid={this.nameHandler}
                />
              </GridColumn>
            </GridRow>
            <GridRow>
              <GridColumn className="nw-returns-inputblock">
                <Label htmlFor="address" className="nw-returns-label">
                  {controls.address}
                </Label>
                <TextAreaInput.component
                  id="address"
                  name="address"
                  textAreaInput={firstLine}
                  className="nw-addaddress-addresstext"
                  onChange={this.addressHandler}
                />
              </GridColumn>
            </GridRow>
            <GridRow>
              <GridColumn className="nwc-grid-col-sm nw-returns-inputblock">
                <Label htmlFor="mobile" className="nw-returns-label">
                  {controls.phone}
                </Label>
                <MobileNumberInput.component
                  name="mobile"
                  id="mobile"
                  placeholder=""
                  className="nw-returns-input"
                  mobileNo={mobileNumber}
                  onChange={this.mobileHandler}
                />
              </GridColumn>
              <GridColumn className="nwc-grid-col-sm nw-returns-inputblock">
                <Label htmlFor="alternatenumber" className="nw-returns-label">
                  {controls.alternateNumber}
                </Label>
                <MobileNumberInput.component
                  name="alternatenumber"
                  id="alternatenumber"
                  placeholder=""
                  className="nw-returns-input"
                  mobileNo={alternateMobileNumber}
                  onChange={this.alternatenumberHandler}
                />
                <div className="nw-returns-alternatenumbererror">
                  {mobileNumberCheck}
                </div>
              </GridColumn>
            </GridRow>
            <GridRow>
              <GridColumn className="nwc-grid-col-sm nw-returns-inputblock">
                <Label htmlFor="pincode" className="nw-returns-label">
                  {controls.pincode}
                </Label>
                <PincodeInput.component
                  name="pincode"
                  id="pincode"
                  placeholder=""
                  value={pincode}
                  className="nw-returns-input"
                  pincodeErrMsg={this.pincodeNotServicableMsg}
                  onChange={this.pincodeHandler}
                />
              </GridColumn>
              <GridColumn className="nwc-grid-col-sm nw-returns-inputblock">
                <Label htmlFor="landmark" className="nw-returns-label">
                  {controls.landmark}
                </Label>
                <Input
                  id="landmark"
                  name="landmark"
                  className="nw-addaddress-landmark"
                  onChange={this.landmarkHandler}
                  value={landmark}
                />
              </GridColumn>
            </GridRow>
            <GridRow className="nw-returns-spaceblock">
              <GridColumn
                className={`nwc-grid-col-xs-6 nw-returns-inputblock ${
                  this.showPicodeData
                }`}
              >
                <Label htmlFor="city" className="nw-returns-label">
                  {controls.city}
                </Label>
                <Label>{city}</Label>
              </GridColumn>
              <GridColumn
                className={`nwc-grid-col-xs-6 nw-returns-inputblock ${
                  this.showPicodeData
                }`}
              >
                <Label htmlFor="state" className="nw-returns-label">
                  {controls.state}
                </Label>
                <Label>{state}</Label>
              </GridColumn>
            </GridRow>
            <GridRow>
              <GridColumn className="nw-returns-buttonblock">
                <Button
                  className="nwc-btn-primary nw-returns-button"
                  type="submit"
                  disabled={!this.isSubmit}
                >
                  {submit}
                </Button>
              </GridColumn>
            </GridRow>
          </GridContainer>
        </form>
      </div>
    );
  }
}

AddAddress.defaultProps = {
  previous: Utils.noop,
  editableAddress: {
    country: "",
    pincode: "",
    mobileNumber: "",
    alternateMobileNumber: "",
    firstLine: "",
    landmark: "",
    name: "",
    state: "",
    city: "",
    id: "",
    isDefault: false,
  },
  edit: false,
  showBackButton: false,
  showLocalLoader: false,
};

AddAddress.wrappedComponent.propTypes = {
  AddressStore: PropTypes.shape({
    getPincodeDetails: PropTypes.func.isRequired,
    addressloader: PropTypes.bool,
  }),
  showLocalLoader: PropTypes.bool,
  onAddressSave: PropTypes.func.isRequired,
  previous: PropTypes.func,
  edit: PropTypes.bool,
  showBackButton: PropTypes.bool,
  editableAddress: PropTypes.shape({
    country: PropTypes.string,
    pincode: PropTypes.string,
    mobileNumber: PropTypes.string,
    alternateMobileNumber: PropTypes.string,
    firstLine: PropTypes.string,
    landmark: PropTypes.string,
    name: PropTypes.string,
    state: PropTypes.string,
    city: PropTypes.string,
    id: PropTypes.string,
    isDefault: PropTypes.bool,
  }),
};

const getFinalComponent = component =>
  inject("AddressStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: AddAddress.wrappedComponent,
  component: AddAddress,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ReturnComponent/AddAddress/index.js